import {Component, Input, OnInit} from '@angular/core';
import {FaqCategory} from '../../../../model/FaqCategory';
import {FormGroup, UntypedFormGroup} from '@angular/forms';
import {UserProductsFormGeneratorService} from '../../../../formulaires/user/user-products-form-generator.service';

import {DynamicFormComponent} from "../../../../components/common/dynamic-form/dynamic-form.component";
import { FieldDefinition } from 'src/app/model/field-definition';
import { QuestionControlService } from 'src/app/components/common/fields/question-control.service';

@Component({
    selector: 'app-user-product-form',
    imports: [
    DynamicFormComponent
],
    templateUrl: './user-product-form.component.html',
    styleUrls: ['./user-product-form.component.css']
})
export class UserProductFormComponent implements OnInit {
  @Input() product: FaqCategory;
  @Input() parentForm!: UntypedFormGroup;
  @Input() canReplace = true;

  questions: FieldDefinition<any>[] = [];
  form!: FormGroup;
  formName: string;

  constructor(
    private userProductsFormGeneratorService: UserProductsFormGeneratorService,
    private questionControlService: QuestionControlService
  ) {
  }

  ngOnInit(): void {
    this.formName = this.product.slug;
    const initialValues = this.parentForm.controls[this.formName]?.value;
    this.loadQuestions(this.canReplace, this.formName, initialValues);
  }

  private loadQuestions(canReplace: boolean, formName: string, values?: any) {
    this.userProductsFormGeneratorService.getQuestions(canReplace, formName, values).subscribe(questions => {
      this.questions = questions;
      this.form = this.questionControlService.toFormGroup(questions, this.onChangedForm());
      this.parentForm.setControl(formName, this.form);
    });
  }

  private onChangedForm() {
    return (values: any) => {
      const shouldReloadQuestions =
        Object.keys(values).length === 1 ||
        (values.transfert === 'libriciel' && values.consultant === undefined) ||
        (values.transfert !== 'libriciel' && values.consultant !== undefined) ||
        (values.replace === 'yes' && values.oldreferentname === undefined) ||
        (values.replace !== 'yes' && values.oldreferentname !== undefined);

      if (shouldReloadQuestions) {
        this.loadQuestions(this.canReplace, this.formName, values);
      }
    };
  }
}
